export const isCategoryContainActiveArticle = ({ pathname, articlesList }) =>
  articlesList.some(({ articleUrl }) => articleUrl === pathname)

export const isiOSDevice = () => /iPad|iPhone|iPod/.test(navigator.userAgent)
